// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1LH7-","fullScreen":"style_fullScreen__27EBH","hidden":"style_hidden__20FA_"};